import { twMerge } from "tailwind-merge";

type FormBuilderUploadPreviewProps = {
  src: string;
  alt: string;
  background?: "light" | "dark";
};

const FormBuilderUploadPreview = ({
  src,
  alt,
  background = "light",
}: FormBuilderUploadPreviewProps) => (
  <div
    className={twMerge(
      "flex h-8 w-32 shrink-0 items-center justify-center overflow-hidden rounded-md border border-gray-300 px-2 py-1.5",
      background === "dark" ? "bg-gray-800" : "bg-white",
    )}
  >
    <img src={src} alt={alt} className="max-h-full max-w-full object-contain" />
  </div>
);

export default FormBuilderUploadPreview;
